import { render, staticRenderFns } from "./Overview-Create.vue?vue&type=template&id=70fec9a6"
import script from "./Overview-Create.vue?vue&type=script&lang=js"
export * from "./Overview-Create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports